import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRedhatopenshiftComponent } from './simple-icons-redhatopenshift.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRedhatopenshiftComponent ],
    exports:      [ SimpleIconsRedhatopenshiftComponent ],
    bootstrap:    []
})
export class SimpleIconsRedhatopenshiftModule {}
